import React from "react";
import NewItemProductCarousel from "./NewItemProductCarousel";
import NewItemsBranchAndLeafCategories from "./NewItemsBranchAndLeafCategories";
import NewItemsHeader from "./NewItemsHeader";
import NewItemsLargestCategories from "./NewItemsLargestCategories";
import NewItemsPopularCategories from "./NewItemsPopularCategories";
import NewItemsShopAllProducts from "./NewItemsShopAllProducts";
import ProductListing from "../ProductListing";
import { NewItemsPageResult } from "./NewItemsPageResult";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";

const NewItemsPage = ({
  featureFlags = {},
  branchCategories,
  facetNavigation,
  largestCategories,
  pageName,
  pageUrl,
  pagination,
  popularCategories,
  products,
  recentlyAddedItems,
  searchTerm,
  showNoSearchResultsMessage,
  showShoppingFeatures,
  submissionUrl,
}: NewItemsPageResult) => {
  return (
    <FeatureFlagProvider featureFlags={featureFlags}>
      <div>
        <NewItemsHeader />
        {showShoppingFeatures && (
          <>
            <div className="bg-white py-4">
              <div className="container">
                {!!recentlyAddedItems?.length && (
                  <NewItemProductCarousel carouselItems={recentlyAddedItems} />
                )}
                {!!largestCategories?.length && (
                  <NewItemsLargestCategories {...{ largestCategories }} />
                )}
                <NewItemsShopAllProducts {...{ submissionUrl }} />
                {!!branchCategories?.length && (
                  <NewItemsBranchAndLeafCategories {...{ branchCategories }} />
                )}
                <h2 className="inline-block font-semibold text-2xl mb-0 mt-8 pb-32 text-center w-full md:text-3xl md:mt-24">
                  Shop Popular New Products
                </h2>
              </div>
            </div>
            {!!popularCategories?.length && (
              <NewItemsPopularCategories {...{ popularCategories }} />
            )}
          </>
        )}
        <ProductListing
          aboveChromeComponent={
            <>
              <h1 className="page-header" hidden>
                {pageName}
              </h1>
              {showNoSearchResultsMessage ? (
                <>
                  <p className="font-semibold text-3xl mb-1 mt-8">
                    Sorry, we couldn&apos;t find any matches for &quot;
                    {searchTerm}
                    &quot;
                  </p>
                  <p className="text-lg">
                    Try searching for another product, or browse all New Items
                    below.
                  </p>
                </>
              ) : (
                <p className="font-semibold text-3xl mt-8">
                  Shop All New Products
                </p>
              )}
            </>
          }
          hasBackground={false}
          hasHeaderData={false}
          hideFilters={false}
          showCategoryFilter
          showPartsFilter={false}
          hideTopper
          {...{
            pagination,
            facetNavigation,
            products,
            pageName,
            pageUrl,
          }}
        />
      </div>
    </FeatureFlagProvider>
  );
};

export default NewItemsPage;
